import { ComposedTheme } from '@glu/theming';

/* istanbul ignore file */
export default ({ palette, typography }: ComposedTheme) => ({
  header: {
    // @theming labelText: Header padding, type: string
    padding: '1px 8px',
    // @theming labelText: Header cursor, type: string
    cursor: 'pointer',
    // @theming labelText: Header text color, type: color
    color: palette.text.dark,
    // @theming labelText: Header line height, type: pixel
    lineHeight: '24px',
    // @theming labelText: Header font family, type: fontFamily
    fontFamily: typography.text.fontFamily,
    // @theming labelText: Header font size, type: pixel
    fontSize: 16,
    // @theming labelText: Input font weight, type: fontWeight
    fontWeight: typography.fontWeightHeavy,
    // @theming labelText: Outline style, type: string
    outlineStyle: `${palette.focus.normal} solid 1px`,
  },
  content: {
    // @theming labelText: Content line height, type: pixel
    lineHeight: '24px',
    // @theming labelText: Content text color, type: color
    color: palette.text.dark,
    // @theming labelText: Content font size, type: pixel
    size: 16,
    // @theming labelText: Content font family, type: fontFamily
    fontFamily: typography.text.fontFamily,
    // @theming labelText: Content font weight, type: fontWeight
    fontWeight: typography.text.fontWeight,
  },
  icon: {
    // @theming labelText: Icon display, type: string
    display: 'flex',
    // @theming labelText: Icon arrow Size, type: pixel
    arrowSize: 16,
    // @theming labelText: Icon arrow Fill, type: color
    arrowFill: palette.text.dark,
    // TODO: Remove unused
    cursor: 'pointer',
  },
  transition: {
    // @theming labelText: Transition duration, type: string
    transitionDuration: '.25s',
    // @theming labelText: Transition function, type: string
    transitionTimingFunction: 'cubic-bezier(0.5, 1, 0.89, 1)',
    // @theming labelText: Transition delay, type: string
    transitionDelay: '0s',
  },
  parentSection: {
    '& h3': {
      // @Fix - see GLU-7558
      margin: 0,
    },
  },
  nestedSection: {
    // @theming labelText: Nested padding, type: string
    padding: '1px 6px 1px 27px',
    '& h3': {
      // @Fix - see GLU-7558
      margin: 0,
    },
  },
});
